/* PetNGo — quick-add de "Completa tu compra". Listener delegado: funciona aunque el carrito se re-renderice. */
(function () {
  if (window.__pnRecoInit) return;
  window.__pnRecoInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pn-reco-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('data-loading')) return;
    btn.setAttribute('data-loading', '1');
    btn.setAttribute('data-done', '1');
    var id = btn.getAttribute('data-variant-id');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: data } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        btn.removeAttribute('data-loading');
        btn.removeAttribute('data-done');
      });
  }, true);
})();